module.exports = __webpack_public_path__ + "5c449284c8bffd8a1a7b5cea411206cb.png";